import { memo } from 'react';
import { HEADER_ROW_HEIGHT } from '../../utils/boardHelpers';
import { formatKwLabel, type VisibleWeek } from './timelineHeaderHelpers';

interface TimelineKwRowProps {
  visibleWeeks: VisibleWeek[];
  dayWidth: number;
  weekWidth: number;
  isLast: boolean;
}

export const TimelineKwRow = memo(function TimelineKwRow({ visibleWeeks, dayWidth, weekWidth, isLast }: TimelineKwRowProps) {
  return (
    <div
      style={{
        position: 'relative',
        height: HEADER_ROW_HEIGHT,
        borderBottom: isLast ? undefined : '1px solid #f1f5f9',
      }}
    >
      {visibleWeeks.map(({ kw, year, startDay }) => {
        const isNewYear = kw === 1;
        return (
          <div
            key={`kw-${year}-${kw}`}
            style={{
              position: 'absolute',
              left: startDay * dayWidth,
              top: 0,
              width: weekWidth,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRight: isNewYear ? '2px solid #3b82f6' : '1px solid #e2e8f0',
              fontSize: 11,
              fontWeight: 600,
              color: isNewYear ? '#3b82f6' : '#334155',
              backgroundColor: isNewYear
                ? 'rgba(59, 130, 246, 0.08)'
                : kw % 2 === 0
                ? 'rgba(0, 0, 0, 0.02)'
                : 'transparent',
            }}
          >
            <span>{formatKwLabel(kw, year, weekWidth)}</span>
          </div>
        );
      })}
    </div>
  );
});
